import state from './moduleSelfServiceState'
import mutations from './moduleSelfServiceMutation'
import actions from './moduleSelfServiceActions'
import getters from './moduleSelfServiceGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

